import Vue from 'vue'
import FeedbackModal from '@/components/FeedbackModal.vue'

class FeedbackManager {
    constructor() {
        this.instance = null
        this.container = null
    }

    /**
     * 创建反馈模块实例
     */
    createInstance() {
        if (this.instance) {
            return this.instance
        }

        // 创建容器元素
        this.container = document.createElement('div')
        document.body.appendChild(this.container)

        // 使用渲染函数创建Vue实例，兼容runtime-only版本
        this.instance = new Vue({
            el: this.container,
            data() {
                return {
                    visible: false,
                    maxLength: 15000,
                    id: '',
                    type: 0
                }
            },
            render(h) {
                return h(FeedbackModal, {
                    ref: 'feedbackModal',
                    props: {
                        value: this.visible,
                        maxLength: this.maxLength,
                        type: this.type,
                        id: this.id
                    },
                    on: {
                        input: (value) => {
                            this.visible = value
                        },
                        submit: (data) => {
                            this.$emit('submit', data)
                        },
                        close: () => {
                            this.$emit('close')
                        }
                    }
                })
            }
        })

        return this.instance
    }

    /**
     * 显示反馈弹窗
     * @param {Object} options - 配置选项
     * @param {number} options.maxLength - 最大字符数限制，默认500
     * @param {Function} options.onSubmit - 提交回调函数
     * @param {Function} options.onCancel - 取消回调函数
     * @param {Function} options.onClose - 关闭回调函数
     */
    show(options = {}) {
        console.log('showFeedback 调用，参数:', options)
        const instance = this.createInstance()

        // 设置配置
        if (options.maxLength) {
            instance.maxLength = options.maxLength
        }

        if (options.id) {
            instance.id = options.id
        }

        if (options.type !== undefined) {
            console.log('设置 type:', options.type)
            instance.type = options.type
        }

        // 清除旧的事件监听器
        instance.$off('submit')
        instance.$off('input')
        instance.$off('close')

        // 设置事件监听
        if (options.onSubmit) {
            instance.$on('submit', options.onSubmit)
        }

        if (options.onCancel) {
            instance.$on('input', (visible) => {
                if (!visible && options.onCancel) {
                    options.onCancel()
                }
            })
        }

        if (options.onClose) {
            instance.$on('close', options.onClose)
        }

        // 在下一个 tick 中获取标签（确保所有参数都已设置）
        instance.$nextTick(() => {
            // 通过 ref 访问 FeedbackModal 组件实例
            const feedbackModalComponent = instance.$refs.feedbackModal
            if (feedbackModalComponent && !feedbackModalComponent.isInitialized) {
                console.log('feedbackManager 中调用 getFeedbackTag，type:', instance.type)
                feedbackModalComponent.getFeedbackTag()
            }
        })

        // 显示弹窗
        instance.visible = true

        return instance
    }

    /**
     * 隐藏反馈弹窗
     */
    hide() {
        if (this.instance) {
            this.instance.visible = false
        }
    }

    /**
     * 销毁反馈模块实例
     */
    destroy() {
        if (this.instance) {
            this.instance.$destroy()
            this.instance = null
        }
        if (this.container && this.container.parentNode) {
            this.container.parentNode.removeChild(this.container)
            this.container = null
        }
    }
}

// 创建单例实例
const feedbackManager = new FeedbackManager()

// 导出便捷方法
export const showFeedback = (options) => {
    return feedbackManager.show(options)
}

export const hideFeedback = () => {
    return feedbackManager.hide()
}

export const destroyFeedback = () => {
    return feedbackManager.destroy()
}

// 导出管理器类
export default feedbackManager

// 全局方法（可选）
if (typeof window !== 'undefined') {
    window.showFeedback = showFeedback
    window.hideFeedback = hideFeedback
} 